import apiClient from '@contexts/AuthContext/apiClient';
import { usersApis } from '@shared/apis';

export const downloadMentorCv = async (userId: string) => {
  const endpoint = usersApis.downloadMentorCv.endpoint.replace(':id', userId);
  const response = await apiClient.get(endpoint, { responseType: 'blob' });

  const disposition = (response.headers?.['content-disposition'] as string) ?? '';
  const filename = disposition.match(/filename="?([^"]+)"?/)?.[1] ?? 'cv';

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
